<template>
  <div class="loading-container">
    <VaSkeletonGroup animation="wave" class="item-card-main-container">
      <VaCard>
        <VaCardContent>
          <div class="mb-3 square-container">
            <VaSkeleton class="square-skeleton" />
          </div>
          <VaSkeleton variant="text" :lines="3" />
        </VaCardContent>
      </VaCard>
    </VaSkeletonGroup>
  </div>
</template>

<script>
</script>

<style scpoed lang="sass">
.item-card-main-container
  height: 18rem
  max-width: 11.438rem
  @media (max-width: 430px)
    max-width: 14rem
    height: 19rem
  @media (max-width: 400px)
    max-width: 12.5rem
    height: 19rem
  @media (max-width: 376px)
    max-width: 11.438rem
  @media (max-width: 325px)
    max-width: 9.3rem
    max-height: 18rem
    margin-right: 1rem

  .square-container
    height: 11.398rem
    width: 8.438rem
    @media (max-width: 325px)
      width: 7rem
    

    .square-skeleton
      height: 100% 
</style>